import { EmptyObject } from 'react-hook-form';

import { customEventFactory } from '@dreryk/react-common';

export const [
   dispatchRefetchUnsignedMedicalInformationAttachmentCountEvent,
   registerRefetchUnsignedMedicalInformationAttachmentCountEventListener,
] = customEventFactory<EmptyObject>('RefetchUnsignedMedicalInformationAttachmentCountEvent');
